<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >
    <template v-slot:activator="{ props }">
      <slot v-bind="{ props }" data-cy="podFiles-tree-actions-exportAsset-activator" name="activator" />
    </template>

    <v-card data-cy="dialog-exportAsset-modal">
      <v-card-title class="d-flex justify-space-between">
        {{ $t('routes.pod.exportAssetToPodTitle') }}

        <v-btn icon @click="dialog = false" :aria-label="$t('common.close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text data-cy="dialog-exportAsset-text">
        <div class="text-body-1 mt-2">
          {{ $t('routes.pod.exportAssetToPodDialogText', { filename: asset.name }) }}
        </div>

        <div v-if="errorMessage" class="bg-error mt-2" data-cy="dialog-exportAsset-error">
          {{ errorMessage }}
        </div>

        <div class="bg-error" v-if="errorTranslatable">
          {{ $replaceT(errorTranslatable.code, errorTranslatable.params, errorTranslatable.content) }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" variant="flat" @click="promoteToPod" data-cy="dialog-exportAsset-ok-btn">
          {{ $t('routes.pod.export') }}
        </v-btn>
        <v-btn variant="text" @click="dialog = false" data-cy="dialog-exportAsset-cancel-btn">
          {{ $t('common.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "ExportAssetDialog",
  props: {
    pod: {
      type: Object,
      required: true,
    },
    asset: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      errorMessage: "",
      errorTranslatable: null,
    }
  },
  watch: {
    dialog: function(newValue) {
      if (newValue) {
        this.errorMessage = "";
      }
    }
  },
  methods: {
    promoteToPod: function() {
      this.errorMessage = "";
      this.errorTranslatable = null;

      let self = this;
      const podStore = usePodStore();
      podStore.promoteAssetToPod(this.asset)
      .then(function() {
        self.dialog = false;
      })
      .catch(function(error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          // self.errorMessage = error.response.data.error.message;
          const apiError = error.response.data.error.message;
          if (typeof apiError == 'object') {
            self.errorTranslatable = apiError;
          } else {
            self.errorMessage = apiError;
          }
        } else {
          self.errorMessage = "Error!";
          console.log(error);   // unhandled error
        }
      });
    },
  },
}
</script>
